module.exports = __webpack_public_path__ + "static/media/takeaway_footer_color.31efef15.svg";